import React from "react";

function TerminalVisual() {
  return (
    <div className="hero-terminal" aria-label="Software systems status preview">
      <div className="hero-terminal-bar">
        <span className="terminal-dot"></span>
        <span className="terminal-dot"></span>
        <span className="terminal-dot"></span>
        <span className="terminal-path">~/saroop/systems</span>
      </div>
      <div className="hero-terminal-body">
        <div className="terminal-command"><span>$</span> ./deploy --production</div>
        <div className="terminal-status"><span className="status-pulse"></span> deployment complete</div>
        <div className="terminal-metrics">
          <div><span>UPTIME</span><strong>99.98%</strong></div>
          <div><span>PIPELINE</span><strong>PASSING</strong></div>
        </div>
        <div className="terminal-graph" aria-hidden="true">
          <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
        </div>
        <div className="terminal-footer"><span>build 2026.09.05</span><span>all systems nominal</span></div>
      </div>
    </div>
  );
}

export default TerminalVisual;
